import { Navigate, Outlet } from "react-router-dom";
import AppNavigation from "@/components/navigation/AppNavigation";
import { HelixLoader } from "@/components/ui/helix-loader";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { useAuth } from "@/contexts/AuthContext";

export default function CourseLayout() {
  const { session, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <HelixLoader className="text-primary" />
      </div>
    );
  }

  if (!session?.user) return <Navigate to="/" replace />;

  return (
    <ThemeProvider>
      <div className="min-h-screen w-full flex flex-col">
        <main className="flex-1 overflow-auto pb-24 md:pb-16">
          <Outlet />
        </main>
        <AppNavigation />
      </div>
    </ThemeProvider>
  );
}
